import {
  THookSelectorFetchDataInfo,
  TSelector,
  useGenFetchDataSelector,
} from 'redux/rootSelectors';
import { ReportBuilderState } from '../reducer';
import {
  TCheckDynamicCatalogDataResult,
  TGetObjectionNextStepData,
  TGetReportData,
  TGetReportSettingsData,
  TGetReportsListData,
} from '../types';

export const selectorReportsList: TSelector<
  ReportBuilderState['reportsTypeList']
> = ({ reportBuilderReducer }) => reportBuilderReducer.reportsTypeList;

export const selectorNextStepData: TSelector<
  ReportBuilderState['nextStepData']
> = ({ reportBuilderReducer }) => reportBuilderReducer.nextStepData;

export const selectorReportSettings: TSelector<
  ReportBuilderState['reportSettings']
> = ({ reportBuilderReducer }) => reportBuilderReducer.reportSettings;

export const selectorNotExistInCatalogKeys: TSelector<
  ReportBuilderState['notExistInCatalogKeys']
> = ({ reportBuilderReducer }) => reportBuilderReducer.notExistInCatalogKeys;

export const selectorGetReport: TSelector<
  ReportBuilderState['reportByFilter']
> = ({ reportBuilderReducer }) => reportBuilderReducer.reportByFilter;

export const useReportsList: THookSelectorFetchDataInfo<
  TGetReportsListData[]
> = () => useGenFetchDataSelector(selectorReportsList);

export const useNextStepData: THookSelectorFetchDataInfo<
  TGetObjectionNextStepData
> = () => useGenFetchDataSelector(selectorNextStepData);

export const useReportSettings: THookSelectorFetchDataInfo<
  TGetReportSettingsData
> = () => useGenFetchDataSelector(selectorReportSettings);

export const useNotExistInCatalogKeys: THookSelectorFetchDataInfo<
  Record<string, TCheckDynamicCatalogDataResult>
> = () => useGenFetchDataSelector(selectorNotExistInCatalogKeys);

export const useReportByFilter: THookSelectorFetchDataInfo<
  TGetReportData
> = () => useGenFetchDataSelector(selectorGetReport);
